import React, { ReactElement, useState } from 'react';
import {
    CarrouselContainer,
    Container,
    BackgroundContainer,
    ArrowContainer,
    IMAGE_WIDTH,
    DescriptionContainer,
    TitleStyle,
    TextStyle,
    StepperItem,
    StepperContainer,
    CloseButton,
} from './Carrousel.style';
import RawModal from '../RawModal';
import { SVGIcon, SVGIcons } from '../Icon/SVGIcon';

type CarrouselData = {
    image: string;
    title: string;
    description: string | ReactElement;
};

export type CarrouselProps<T> = {
    data: CarrouselData[];
    isOpen: boolean;
    onHide: () => void;
};

const Carrousel = <T extends unknown>({ isOpen, onHide, data }: CarrouselProps<T>): ReactElement => {
    const [currentStep, setCurrentStep] = useState(0);
    const displayPreviousArrow = currentStep > 0;
    const displayNextArrow = currentStep < data.length - 1;

    const onNextStep = () => {
        setCurrentStep(currentStep + 1);
    };

    const onPreviousStep = () => {
        setCurrentStep(currentStep - 1);
    };
    return (
        <RawModal isOpen={isOpen} onHide={onHide} width={IMAGE_WIDTH}>
            <CarrouselContainer>
                <Container>
                    <BackgroundContainer>
                        <CloseButton onClick={onHide}>✕</CloseButton>
                        {displayPreviousArrow ? (
                            <ArrowContainer onClick={onPreviousStep}>
                                <SVGIcon icon={SVGIcons.ARROW_BACKWARD} size={20} />
                            </ArrowContainer>
                        ) : (
                            <div />
                        )}
                        <img src={data[currentStep].image} />
                        {displayNextArrow ? (
                            <ArrowContainer onClick={onNextStep}>
                                <SVGIcon icon={SVGIcons.ARROW_FORWARD} size={20} />
                            </ArrowContainer>
                        ) : (
                            <div />
                        )}
                    </BackgroundContainer>
                    <DescriptionContainer>
                        <TitleStyle type="small" weight="bold" text={data[currentStep].title} />
                        <TextStyle type="normal" weight="light" text={data[currentStep].description} />
                    </DescriptionContainer>
                </Container>
                <StepperContainer>
                    {data.map((_, index) => (
                        <StepperItem key={index} isActive={index === currentStep} />
                    ))}
                </StepperContainer>
            </CarrouselContainer>
        </RawModal>
    );
};

export default Carrousel;
